export default "__VITE_ASSET__D1lgja2Y__"